import { PagesId } from '@ts-enums/PagesId'
import { Translations } from '@ts-types/Translations'

const globalTranslations: Translations = {
  es: {
    seo_title: 'Términos y Condiciones',
    description:
      'Consulta los Términos y Condiciones de wicadu y conoce las reglas y condiciones para administrar tu tienda en línea de manera segura y efectiva.',
    seo_keywords:
      'wicadu, términos y condiciones, acuerdo de usuario, normas de la plataforma, condiciones del servicio, políticas de e-commerce, regulaciones de tiendas, términos comerciales, terminos y condiciones',
    breadcrumbs: {
      home: 'Inicio',
      legal: 'Políticas y Cumplimiento',
      terms_and_conditions: 'Términos y Condiciones',
    },
    page_id: PagesId.LegalTermsAndConditions,
    article: {
      title: 'Términos y Condiciones',
      description: 'Por favor, visita la versión en inglés',
    },
  },
  en: {
    seo_title: 'Terms and Conditions',
    seo_description:
      "Read wicadu's Terms and Conditions and learn about the rules and conditions for managing your online store safely and effectively",
    seo_keywords:
      'wicadu, terms and conditions, user agreement, platform rules, service terms, e-commerce policies, store regulations, acceptable use policy, online business terms, term and conditions',
    breadcrumbs: {
      home: 'Home',
      legal: 'Policies and Compliance',
      terms_of_use: 'Terms and Conditions',
    },
    page_id: PagesId.LegalTermsAndConditions,
    article: {
      title: 'Terms and Conditions',
      description: 'By creating an account, or using the Services, you agree to these Terms. If you are accepting on behalf of a company or other entity, you represent that you have authority to bind that entity, and "you" refers to that entity',
      who_we_are_and_how_these_terms_work: {
        title: 'Who we are and how these Terms work',
        seo_title: 'Who we are and how these Terms work?',
        content: [
          'These Terms and Conditions (Terms) govern your access to and use of the wicadu software-as-a-service platform, tools, and related websites, applications, and services (collectively, the Services)',
          'The Services are provided by w SpA, a corporation organized under the laws of Chile, doing business as wicadu (wicadu, we, our, us). wicadu is a registered brand in Chile',
        ],
      },
      content_and_intellectual_property: {
        title: 'Content and Intellectual Property',
        seo_title:
          'What intellectual property rights apply to content on wicadu?',
        content: [
          'All content available on wicadu, including but not limited to images, texts, graphics, logos, icons, and videos, is the exclusive property of wicadu or its respective owners. It is prohibited to use any content from wicadu without prior written authorization from wicadu',
        ],
      },
      user_responsibility: {
        title: 'User Responsibility',
        seo_title: "What are the user's responsibilities when using wicadu?",
        content: [
          'wicadu is not responsible for illegal or inappropriate content uploaded by users. It is the sole responsibility of the user to ensure that all content uploaded to the platform is legal and does not infringe upon the intellectual property rights or other rights of third parties.',
          "wicadu reserves the right to remove any content it deems inappropriate without prior notice. Furthermore, wicadu will not be liable for any damage or harm resulting from the user's improper use of the platform",
        ],
      },
      modifications_of_terms: {
        title: 'Modifications to the Terms and Conditions',
        seo_title: 'Will the Terms and Conditions of wicadu change over time?',
        content: [
          "wicadu reserves the right to modify these terms and conditions at any time and without prior notice. It is the user's responsibility to periodically review these terms and conditions",
        ],
      },
      third_party_services_hosting_and_dependencies: {
        title: 'Third-party services; hosting and dependencies',
        seo_title: 'Third-party services; hosting and dependencies',
        content: [
          'Hosting and providers. You acknowledge and agree that the Services are hosted and delivered using third-party infrastructure and providers (including, without limitation, Auth0, Cloudflare, OpenAI, AWS, Microsoft Azure and Paddle). Your data may be processed and stored by such providers in locations they operate. wicadu is not responsible for acts or omissions of third-party providers',
          'Integrations. If you enable or use third-party services, apps, or plugins with the Services, your use of those third-party offerings is subject to their terms and privacy policies. wicadu is not responsible for third-party services and may disable integrations that pose security, legal, or operational risks',
        ],
      },
      availability_maintenance_third_party_outages: {
        title: 'Availability; maintenance; third-party outages',
        seo_title: 'Availability; maintenance; third-party outages',
        content: [
          'No uninterrupted service. The Services may be unavailable or degraded due to maintenance, updates, security patches, emergencies, force majeure, or outages of third-party providers (for example, if Cloudflare, AWS or Azure is down). You acknowledge that the Services may be offline at any time and agree that wicadu has no liability for such downtime',
          'Data backups. You are responsible for exporting or backing up your content as appropriate for your business needs',
        ],
      },
      privacy_and_marketing_use_of_data: {
        title: 'Privacy and marketing use of data',
        seo_title: 'Privacy and marketing use of data',
        content: [
          'Privacy. wicadu will handle personal data as described in wicadu\'s Privacy Policy. You are responsible for providing legally compliant notices to, and obtaining any required consents from, your Users and your buyers',
          'Marketing communications and marketing use. You consent to wicadu using your contact information and account usage information for wicadu\'s marketing and product communications, including email and in-product messages. You also consent to wicadu using aggregated or de-identified data to improve and market the Services. You may opt out of direct marketing communications at any time via unsubscribe links or by contacting wicadu Help Center. Opting out may not limit service or transactional messages',
        ],
      },
      security: {
        title: 'Security',
        seo_title: 'Security',
        content: [
          'wicadu implements reasonable administrative, technical, and physical safeguards designed to protect the Services and your data. However, no system is perfectly secure, and you acknowledge that you provide data at your own risk consistent with these Terms',
        ],
      },
      ip_ownership_feedback: {
        title: 'IP ownership; feedback',
        seo_title: 'IP ownership; feedback',
        content: [
          'IP. As between the parties, the owner of wicadu holds all rights, title, and interest in and to the Services, including software, technology, designs, templates, documentation, and all related intellectual property rights. Except for the limited rights expressly granted, no rights are granted to you',
          'Feedback. If you provide feedback or suggestions, wicadu may use them without restriction or obligation',
        ],
      },
      claims_of_ip_infringement_notice_and_takedown: {
        title: 'Claims of IP infringement; notice and takedown',
        seo_title: 'Claims of IP infringement; notice and takedown',
        content: [
          'wicadu may remove or disable access to any content alleged to infringe intellectual property rights and may terminate repeat infringers. To submit an IP complaint, contact wicadu Help Center with: (a) identification of the work or right claimed to be infringed; (b) identification of the allegedly infringing material and its location; (c) your contact details; (d) a statement of good-faith belief that the disputed use is not authorized; and (e) a statement that the information is accurate and that you are the rights holder or authorized to act for the rights holder. wicadu may share your notice with the user who posted the content',
        ],
      },
      suspension_and_termination: {
        title: 'Suspension and termination',
        seo_title: 'Suspension and termination',
        content: [
          'By wicadu for cause. We may suspend or terminate all or part of the Services (including account access) immediately if we believe you or your Users have violated these Terms, pose a security or legal risk, or cause harm to the Services or others',
          'By you. You may cancel at any time via your account settings; cancellation takes effect at the end of your current billing term unless otherwise provided',
          'Effect. Upon termination or expiration, your right to access the Services ends, and we may delete or disable access to your account and content after a reasonable period, except where we are legally required to retain data',
          'Refunds. If your account is suspended or terminated for violation of these Terms or other misuse (including IP infringement), you are not entitled to any refunds for amounts already paid, and any unpaid amounts become immediately due',
        ],
      },
      warranties_and_disclaimers: {
        title: 'Warranties and disclaimers',
        seo_title: 'Warranties and disclaimers',
        content: [
          'You represent and warrant that you have all necessary rights to your User Content and your stores, and that your use of the Services complies with law',
          'The Services are provided "as is" and "as available." To the maximum extent permitted by law, wicadu disclaims all warranties, express, implied, or statutory, including merchantability, fitness for a particular purpose, non-infringement, and any warranties arising from course of dealing or usage of trade. wicadu does not warrant that the Services will be uninterrupted, error-free, or secure, or that content will be preserved or free from loss or corruption',
        ],
      },
      limitation_of_liability: {
        title: 'Limitation of liability',
        seo_title: 'Limitation of liability',
        content: [
          'To the maximum extent permitted by law, wicadu will not be liable for any indirect, incidental, special, consequential, exemplary, or punitive damages, or for loss of profits, revenues, goodwill, data, or business interruption, even if advised of the possibility',
          'wicadu\'s aggregate liability for all claims arising out of or related to the Services or these Terms will not exceed the amounts you paid to wicadu for the Services giving rise to the claim in the twelve (12) months before the first event giving rise to liability',
          'The limitations in this section apply even if any limited remedy fails of its essential purpose and to all theories of liability',
          'Indemnification. You will defend, indemnify, and hold harmless wicadu, its affiliates, and their officers, directors, employees, and agents from and against any third-party claims, damages, liabilities, costs, and expenses (including reasonable attorneys\' fees) arising out of or related to: (a) your User Content; (b) your stores, products, or services; (c) your use of the Services in violation of these Terms or law; or (d) alleged infringement or violation of rights by your content or activities',
          'Export controls and sanctions. You represent that you and your Users are not subject to sanctions and will not use the Services in violation of applicable export control and sanctions laws. You will not permit Users in embargoed or restricted territories to access the Services',
          'Force majeure. wicadu will not be liable for delays or failures caused by events beyond its reasonable control, including failures of third-party hosting, networks, or utilities; denial-of-service attacks; acts of God; labor disputes; or governmental actions',
        ],
      },
      governing_law_and_jurisdiction: {
        title: 'Governing law and jurisdiction',
        seo_title: 'Governing law and jurisdiction',
        content: [
          'These Terms, the Services, and any dispute or claim arising out of or relating to them are governed by the laws of the Republica de Chile, without regard to conflict-of-law rules',
          'Exclusive venue. The parties irrevocably submit to the exclusive jurisdiction of the courts of Santiago de Chile, and waive any objection to venue or inconvenient forum there',
          'Consumers. If you are a consumer and mandatory law provides otherwise, this section does not limit your non-waivable rights',
        ],
      },
      changes_to_the_services_and_to_these_terms: {
        title: 'Changes to the Services and to these Terms',
        seo_title: 'Changes to the Services and to these Terms',
        content: [
          'We may modify the Services and these Terms from time to time. If we make material changes to the Terms, we will provide notice (for example, via email or in-product). Changes are effective on the stated effective date. If you continue using the Services after the effective date, you accept the changes. If you do not agree, you must stop using the Services before the changes take effect',
        ],
      },
      miscellaneous: {
        title: 'Miscellaneous',
        seo_title: 'Miscellaneous',
        content: [
          'Entire agreement. These Terms, any order, and any policies referenced herein (including the Privacy Policy) form the entire agreement between you and wicadu regarding the Services and supersede prior or contemporaneous agreements on the same subject',
          'Assignment. You may not assign these Terms without wicadu\'s prior written consent. wicadu may assign these Terms to an affiliate or in connection with a merger, acquisition, corporate reorganization, or sale of assets',
          'Severability; waiver. If any provision is found unenforceable, it will be modified to reflect the parties\' intent or, if not possible, severed, and the remaining provisions will remain in effect. No waiver of any term is a further or continuing waiver',
          'Relationship. The parties are independent contractors; no agency, partnership, or joint venture is intended or created'
        ],
      },
      notices: {
        title: 'Notices',
        seo_title: 'Notices',
        content: [
          'wicadu notices may be provided via the Services, email, or your account address. Your legal notices to wicadu must be sent to: w SpA `77 (dot) 695 (dot) 519 (dash) 7`, Cerro El Plomo 5931 - Office 1213, Región Metropolitana, Chile; and by email to `legal (at) wicadu (dot) com`',
          'IP complaints must follow Section "Claims of IP infringement; notice and takedown"',
        ],
      },
      date: {
        content: [
          'Effective date: August 21, 2025',
          'Last updated: August 21, 2025'
        ]
      },
    },
  },
  fr: {
    seo_title: 'Conditions générales',
    seo_description:
      'Consultez les conditions générales de wicadu et découvrez les règles et conditions pour gérer votre boutique en ligne de manière sûre et efficace.',
    seo_keywords:
      "wicadu, conditions générales, accord d'utilisation, règles de la plateforme, conditions du service, politiques e-commerce, réglementation des boutiques, conditions commerciales",
    breadcrumbs: {
      home: 'Accueil',
      legal: 'Politiques et conformité',
      terms_and_conditions: 'Conditions générales',
    },
    page_id: PagesId.LegalTermsAndConditions,
    article: {
      title: 'Conditions générales',
      description: 'Veuillez consulter la version anglaise',
    },
  },
  pt: {},
}


export default globalTranslations
